<template>
  <div class="flex flex-col justify-center m-auto h-screen text-center">
    <div class="text-6xl font-black">4😭4</div>
    <h2 class="text-3xl font-bold">Oops! Even rockstars make mistakes</h2>
    <p class="text-xl pb-12">The page you are looking for does not exist, has been removed, has had its name changed, or is temporarily unavailable</p>
    <router-link to="/">
      <STButton
      :options="buttonOptions"
      class="w-64 m-auto"
      />
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'AppNotFound',
  data () {
    return {
      buttonOptions: {
        'text': 'Back to Homepage'
      }
    }
  }
}
</script>
